import chain from '@/lib/axios-chain'

// 获取配置信息
export const getXiaomanBaseInfo = () => chain.create('/config/xiaoman/baseInfo', 'get')

// 获取系统内的字段
export const getXiaomanFields = () => chain.create('/config/xiaoman/getFields', 'get')

// 实时获取小满成员
export const getXiaomanSyncMember = () => chain.create('/config/xiaoman/syncMember', 'get')

// 实时获取小满字段信息
export const getXiaomanSyncFields = () => chain.create('/config/xiaoman/syncFields', 'get')

// 更新小满开关
export const upXiaomanIsOpen = () => chain.create('/config/xiaoman/upIsopen', 'post')

// 更新小满主帐号
export const upXiaomanAccount = () => chain.create('/config/xiaoman/upAccount', 'post')

// 更新帐号绑定关系
export const upXiaomanUserBind = () => chain.create('/config/xiaoman/upUserBind', 'post')

// 更新字段对应关系
export const upXiaomanFieldAssoc = () => chain.create('/config/xiaoman/upFieldAssoc', 'post')
